import { Icon } from '@/new/components/icon';
import { Checkbox } from '@/new/components/shadcn/checkbox';
import { DialogDescription } from '@/new/components/shadcn/dialog';

export const LARGE_EXPORT_WARNING_THRESHOLD = 10000;
export const LARGE_EXPORT_BLOCK_THRESHOLD = 100000;

interface Props {
  totalCount: number;
  acknowledged: boolean;
  onAcknowledgedChange: (value: boolean) => void;
}

export const LargeExportWarning = ({ totalCount, acknowledged, onAcknowledgedChange }: Props) => (
  <div className="flex flex-col gap-2 rounded-md border border-amber-200 bg-amber-50 p-3 text-sm text-amber-900">
    <div className="flex items-start gap-2">
      <Icon className="lucide--triangle-alert mt-0.5 shrink-0" />
      <DialogDescription className="text-amber-900">
        This export contains {totalCount.toLocaleString()} items and may take a while to complete. You'll be able to
        keep working while it runs.
      </DialogDescription>
    </div>
    <label className="flex cursor-pointer items-center gap-2 pl-6">
      <Checkbox checked={acknowledged} onCheckedChange={(checked) => onAcknowledgedChange(checked === true)} />
      <span>I understand this export may take a while.</span>
    </label>
  </div>
);

export const LargeExportBlock = ({ totalCount }: Pick<Props, 'totalCount'>) => (
  <div className="flex items-start gap-2 rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-900">
    <Icon className="lucide--ban mt-0.5 shrink-0" />
    <DialogDescription className="text-red-900">
      This export contains {totalCount.toLocaleString()} items. Downloads are limited to{' '}
      {LARGE_EXPORT_BLOCK_THRESHOLD.toLocaleString()} items; reduce the number of items and try again.
    </DialogDescription>
  </div>
);
